import React from 'react'
import img from '../../assets/Images/discount-using-credit-card (1) 1.png'
import Commisions from './Commisions'
import ReferFriends from './ReferFriends'
import styled from 'styled-components'
import './Rewards.css'
import { Link } from 'react-router-dom'
import { Join } from './join'
import { RewardNews } from './rewardNews'

const Div = styled.div`
background-color: #EEF2F6;
padding: 60px 0;
`

const Button = styled.button`
padding: 0.5rem 3rem;
background-color: #F7A601;
border-radius: 32px;
color: black;
font-weight: 600; 
border: none;
text-decoration: none;
outline: none;

`
const Button1 = styled.button`
padding: 0.5rem 3rem;
background-color: #F7A601;
border-radius: 32px;
color: black;
font-weight: 600;
font-size: 22px; 
border: none;
text-decoration: none;
outline: none;
`

const Rewards = () => {
    return (
        <>
            <div className='container-fluid m-0 p-0'>
                <div className='qvani-refral-rwrd d-flex justify-content-between align-items-center row mx-2 mx-md-5'>
                    <div className='col-md-8 col-sm-12' style={{ marginTop: "6rem" }}>
                        <h1 className='fw-bold mb-5 text-center text-md-start'>Invite Friends to Earn <br/><span className='cb'>Up to 40% Commissions</span> <br/>Unlimited Referrals, Unlimited Rewards.</h1>
                        <p className='rewrds-para fs-5 text-dark mb-3'>For a limited time only, get paid for bringing people to Qvani. Invite friends to sign up and trade to share high commission rewards.</p>
                        <div className='d-flex justify-content-center justify-content-md-start'>
                            <Button as={Link} to='/login'>Join & Start Earning Now</Button>
                        </div>
                    </div>
                    <div className='col-md-4 col-sm-12 text-end'>
                        <img src={img} alt="" className='w-100' />
                    </div>
                </div>
                {/* <RewardNews/> */}
                <Commisions/>
                <ReferFriends/>
            </div>
            <Div className='row m-0 mt-5 d-flex justify-content-center align-items-center gap-2'>
                <div className='col-sm-10 text-center'>
                    <h2 className='fw-bold fs-1 text-center mb-4'>
                        <span className='d-lg-block'>We share up to <span className='cb'>40% of our <br/> revenue </span> with the <span className='cb'>Qvani<br/> community. </span></span>
                    </h2>
                    <Button1 as={Link} to='/signup'>Join</Button1>
                </div>
            </Div>

            <Join/>
        </>
    )
}

export default Rewards;